// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"fada5834f374b748cc45","678":"671cd50773f346cd4821","883":"645f7a2ac24f25c273e4"}[chunkId] + ".js";
};